






import { Vue, Component, Prop, Watch } from "vue-property-decorator";

export interface TabItemData {
    id: string;
    title: string;
    active: boolean;
    count: number;
}

@Component({})
export default class TabItem extends Vue {

    @Prop() tab: TabItemData;
    @Prop({}) isActive: boolean;

    mounted() {
        this.onIsActiveChanged();
    }

    @Watch('isActive')
    onIsActiveChanged() {
        if (!this.isActive) { return; }

        this.$emit('active', this.tab);
    }

    onMouseOver() {
        this.$emit('mouseover', this.$el);
    }

    onMouseLeave() {
        this.$emit('mouseleave', this.$el);
    }
}

